// Imports
import striptags from 'striptags';


/** Converts HTML to a snippet with limited length, no formatting */
export default function convertHTMLToSnippet(text: string, limit = 20, preserveCutOffLinks?: boolean) {
	// Strip table tags and convert to [table]
	const textWithoutTables = text.replace(/<table[^>]*>[\s\S]*?<\/table>/gi, '[table]');
	
	
	// Strip all tags except image tags
	const textWithImageTags = striptags(textWithoutTables, ['img'], '');
	
	
	// Strip image tags and convert to [photo]
	const textWithoutFormatting = striptags(textWithImageTags, [], '[photo]');
	
	
	// Return
	return convertTextToSnippet(textWithoutFormatting, limit, preserveCutOffLinks);
}


/** Converts text to a snippet with limited length */
export function convertTextToSnippet(text: string, limit = 20, preserveCutOffLinks?: boolean) {
	// Collapse whitespace
	const normalizedText = text.replace(/\s+/g, ' ').trim();
	
	
	// Build regex with imposed limit
	const regex = RegExp(`^(.{${limit - 1}})(.)(.+)$`);
	
	
	// Limit length and add ellipses if needed
	return normalizedText.replace(regex, (_match, start: string, replaced: string, after: string) => {
		// Target links that would be cut off
		if (preserveCutOffLinks) {
			// Build whole link
			const startWords = start.split(/\s/);
			const cutOffStart = startWords.pop() ?? ' ';
			const cutOffEnd = `${replaced}${after}`.split(/\s/)[0];
			const cleanLink = `${cutOffStart}${cutOffEnd}`.replace(/[^a-zA-Z0-9\-._~:/?#@!$&*+;%=]/g, '');
			
			
			// Point the cut off link to its intended URL
			if (/^(https?:\/\/|www\.)/.test(cleanLink)) {
				// Initialize
				const href = /^https?:\/\//.test(cleanLink) ? cleanLink : `https://${cleanLink}`;
				
				
				// Return
				return `${[
					...startWords,
					cutOffStart.replace(
						/^([^a-zA-Z0-9\-._~:/?#@!$&*+;%=])?(.*)$/,
						(_match, wrapper: string | undefined, linkText: string) =>
							`${wrapper ?? ''}${linkText ? `<a href="${href}">${linkText}</a>` : ''}`
					),
				]
					.join(' ')
					.trim()}…`;
			}
		}
		
		
		// Target encoded characters that would be cut off
		if (/^.{0,4};/.test(`${replaced}${after}`)) {
			return `${start.replace(/&.{0,4}$/, '').trim()}…`;
		}
		
		
		// Target [table] or [photo] that would be cut off
		if (/^[tablepho]{0,5}\]/.test(`${replaced}${after}`)) {
			return `${start.replace(/\[[tablepho]{0,5}$/, '').trim()}…`;
		}
		
		
		// Return
		return `${start.trim()}…`;
	});
}
